import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {ActionToggleSidebar} from '../../../store/actions/actions-pages';
import {SidebarBurgerArrow, SidebarBurgerLine} from '../../SvgComponents/SvgComponents';
import './HeaderBurger.less';

function HeaderBurger({hideSidebar, isDesktop}) {
  const dispatch = useDispatch();

  const toggleSidebar = useCallback(() => {
    dispatch(ActionToggleSidebar());
  }, []);

  const getIcon = useMemo(() => {
    if (isDesktop) {
      return (
        <>
          <SidebarBurgerLine />
          <SidebarBurgerArrow className={hideSidebar ? 'closed' : ''} />
        </>
      );
    }

    if (!hideSidebar) {
      return (
        <svg
          className="mobile-burger-icon"
          id="e09m3xopkh1ve1"
          width="44"
          height="44"
          viewBox="0 0 44 44"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        >
          <g id="e09m3xopkh1ve2">
            <g id="e09m3xopkh1ve3" transform="matrix(1 0 0 1 -8 -85)">
              <g id="e09m3xopkh1ve4" transform="matrix(1 0 0 1 8 85)">
                <rect
                  id="svg-layer-1"
                  width="20"
                  height="2"
                  rx="0"
                  ry="0"
                  transform="matrix(1 0 0 1 12 21)"
                  fill="rgb(18,135,251)"
                  fillRule="evenodd"
                  stroke="none"
                  strokeWidth="1"
                />
                <g id="svg-layer-2" transform="translate(22,17)">
                  <g id="svg-layer-3" transform="rotate(0)">
                    <rect
                      id="e09m3xopkh1ve7"
                      width="20"
                      height="2"
                      rx="0"
                      ry="0"
                      transform="translate(-10,-1)"
                      fill="rgb(18,135,251)"
                      fillRule="evenodd"
                      stroke="none"
                      strokeWidth="1"
                    />
                  </g>
                </g>
                <g id="svg-layer-4" transform="translate(22,27)">
                  <g id="svg-layer-5" transform="rotate(0)">
                    <rect
                      id="e09m3xopkh1ve8"
                      width="20"
                      height="2"
                      rx="0"
                      ry="0"
                      transform="translate(-10,-1)"
                      fill="rgb(18,135,251)"
                      fillRule="evenodd"
                      stroke="none"
                      strokeWidth="1"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    }

    return (
      <svg
        id="e4jjtsmkhtsb1"
        className="mobile-burger-icon"
        width="44"
        height="44"
        viewBox="0 0 44 44"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
      >
        <g id="e4jjtsmkhtsb2">
          <g id="e4jjtsmkhtsb3" transform="matrix(1 0 0 1 -8 -85)">
            <g id="e4jjtsmkhtsb4" transform="matrix(1 0 0 1 8 85)">
              <rect
                id="svg-layer-6"
                width="20"
                height="2"
                rx="0"
                ry="0"
                transform="matrix(1 0 0 1 12 21)"
                fill="rgb(18,135,251)"
                fillOpacity="0"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              />
              <g id="svg-layer-7" transform="translate(22,22)">
                <g id="svg-layer-8" transform="rotate(45)">
                  <rect
                    id="e4jjtsmkhtsb7"
                    width="20"
                    height="2"
                    rx="0"
                    ry="0"
                    transform="translate(-10,-1)"
                    fill="rgb(18,135,251)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  />
                </g>
              </g>
              <g id="svg-layer-9" transform="translate(22,22)">
                <g id="svg-layer-10" transform="rotate(-45)">
                  <rect
                    id="e4jjtsmkhtsb8"
                    width="20"
                    height="2"
                    rx="0"
                    ry="0"
                    transform="translate(-10,-1)"
                    fill="rgb(18,135,251)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }, [hideSidebar, isDesktop]);

  return (
    <button type="button" className="burger-button" onClick={toggleSidebar}>
      {getIcon}
    </button>
  );
}

HeaderBurger.defaultProps = {
  hideSidebar: false,
  isDesktop: true,
};

HeaderBurger.propTypes = {
  hideSidebar: PropTypes.bool,
  isDesktop: PropTypes.bool,
};

export default HeaderBurger;
